import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9936e989"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  class: "fw-bold fs-6 w-100 small-text text-break",
  style: {"color":"black"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "d-inline small-text"
}
const _hoisted_6 = {
  key: 1,
  class: "d-inline small-text"
}
const _hoisted_7 = { class: "d-flex flex-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary px-2" }, " Ajouter ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary px-2" }, " Retirer ", -1))

import { CartProduct } from '@/services/flyingBlue';
import NutriscoreDisplay from '@/components/common/nutriscore/NutriscoreDisplay.vue';
import useCurrentShoppingSessionStore from '@/stores/shopping/currentShoppingSessionStore';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardAdd',
  props: {
    cartProduct: {},
    addToOtherProducts: { type: Boolean },
    truncateProductName: { type: Boolean }
  },
  emits: ['addProduct', 'productTap'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const currentShoppingSessionStore = useCurrentShoppingSessionStore();

const productId = computed(() => props.cartProduct.id);
const qty = ref(Math.max(props.cartProduct.id, 1));

function isProductInCart() {
  return currentShoppingSessionStore.isProductInCart(props.cartProduct.product);
}

const inCart = ref(isProductInCart());

const addProduct = (product: CartProduct) => {
  currentShoppingSessionStore.addProduct(product, props.addToOtherProducts);
  emits('addProduct', product);
  inCart.value = true;
};

const removeProduct = (product: CartProduct) => {
  currentShoppingSessionStore.removeProduct(product);
  inCart.value = false;
};

const incrementProductQty = () => {
  currentShoppingSessionStore.incrementProductQty(productId.value, 1);
  qty.value += 1;
};
const decrementProductQty = () => {
  if (qty.value > 1) {
    currentShoppingSessionStore.decrementProductQty(productId.value, 1);
    qty.value -= 1;
  }
};

const showDetailProduct = () => {
  emits('productTap', props.cartProduct.product.id);
};


return (_ctx: any,_cache: any) => {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.cartProduct.product)
    ? (_openBlock(), _createBlock(_component_ion_row, {
        key: 0,
        class: "ion-padding"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            size: "4",
            class: "px-3 my-auto"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                alt: "",
                class: "img-fluid",
                src: _ctx.cartProduct.product?.default_image,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetailProduct()))
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.truncateProductName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.cartProduct.product?.name.slice(0, 20)) + " " + _toDisplayString(_ctx.cartProduct.product.name.length ?? 0 > 20 ? '...' : ''), 1))
                  : _createCommentVNode("", true),
                (!_ctx.truncateProductName)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.cartProduct.product?.name), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(NutriscoreDisplay, {
                class: "d-inline my-2 me-2",
                rating: _ctx.cartProduct.product.nutriscore_grade ?? 'a'
              }, null, 8, ["rating"]),
              (_ctx.cartProduct.product?.weight > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(Number(_ctx.cartProduct.product?.weight)?.toFixed(2)) + "kg ", 1))
                : _createCommentVNode("", true),
              (_ctx.cartProduct.product?.weight == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.cartProduct.product?.packaging_label), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createVNode(_component_ion_buttons, { class: "justify-content-between" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ion_button, {
                        size: "small",
                        class: "incrementation-button incrementation-button-start",
                        onClick: decrementProductQty
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" - ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        size: "small",
                        class: "incrementation-button increment-button-central"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(qty.value), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_button, {
                        size: "small",
                        class: "incrementation-button incrementation-button-end",
                        onClick: incrementProductQty
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" + ")
                        ]),
                        _: 1
                      })
                    ]),
                    (!inCart.value)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          size: "small",
                          fill: "solid",
                          color: "tertiary",
                          shape: "round",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (addProduct(_ctx.cartProduct)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (inCart.value)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 1,
                          size: "small",
                          fill: "solid",
                          color: "tertiary",
                          shape: "round",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (removeProduct(_ctx.cartProduct)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_button, { size: "small" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(Number(_ctx.cartProduct?.price)) + "€ ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})